window.TEV_ICE_DATA = [
  {
    id: "bmw_320i_auto",
    status: "active",
    brand: "BMW",
    model: "3 Series",
    variant: "320i Auto",
    display_name: "BMW 320i Auto",
    fuel_type: "petrol",
    segment: "premium_family",
    body_type: "saloon",
    size_class: "D",

    pricing: {
      new_price_gbp: 44575,
      used_price_bands_gbp: {
        "2_4": 23995,
        "5_7": 17995,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 42.8,
      co2_g_km: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: null
    },

    cost_links: {
      maintenance_band: "petrol_premium_family",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 6,
      motorway_fit: 9,
      family_fit: 7,
      premium_feel: 8,
      long_term_confidence: 7
    },

    notes: {
      short_reason: "Strong premium petrol benchmark.",
      tradeoff: "Higher fuel spend over time."
    }
  },

  {
    id: "bmw_320d_auto",
    status: "active",
    brand: "BMW",
    model: "3 Series",
    variant: "320d Auto",
    display_name: "BMW 320d Auto",
    fuel_type: "diesel",
    segment: "premium_family",
    body_type: "saloon",
    size_class: "D",

    pricing: {
      new_price_gbp: 46575,
      used_price_bands_gbp: {
        "2_4": 25995,
        "5_7": 18995,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 57.6,
      co2_g_km: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: null
    },

    cost_links: {
      maintenance_band: "diesel_premium_family",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 5,
      motorway_fit: 9,
      family_fit: 7,
      premium_feel: 8,
      long_term_confidence: 7
    },

    notes: {
      short_reason: "Efficient long-distance diesel benchmark.",
      tradeoff: "Diesel maintenance and fuel can still add up."
    }
  },

  {
    id: "hyundai_kona_1_0t_petrol",
    status: "active",
    brand: "Hyundai",
    model: "Kona",
    variant: "1.0T Petrol",
    display_name: "Hyundai Kona 1.0T Petrol",
    fuel_type: "petrol",
    segment: "compact_suv",
    body_type: "suv",
    size_class: "C",

    pricing: {
      new_price_gbp: 27270,
      used_price_bands_gbp: {
        "2_4": 15995,
        "5_7": null,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 47.1,
      co2_g_km: null
    },

    warranty: {
      basic_years: 5,
      basic_miles: null
    },

    cost_links: {
      maintenance_band: "petrol_compact_suv",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 7,
      motorway_fit: 7,
      family_fit: 7,
      premium_feel: 5,
      long_term_confidence: 7
    },

    notes: {
      short_reason: "Good mainstream compact SUV petrol comparator.",
      tradeoff: "Fuel costs are much higher than EV over time."
    }
  }
  ,
  {
    id: "vw_tiguan_1_5_tsi_petrol",
    status: "active",
    brand: "Volkswagen",
    model: "Tiguan",
    variant: "1.5 TSI Petrol",
    display_name: "Volkswagen Tiguan 1.5 TSI Petrol",
    fuel_type: "petrol",
    segment: "family_suv",
    body_type: "suv",
    size_class: "D",

    pricing: {
      new_price_gbp: 36500,
      used_price_bands_gbp: {
        "2_4": 24995,
        "5_7": 18995,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 42.2,
      co2_g_km: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: 60000
    },

    cost_links: {
      maintenance_band: "petrol_family_suv",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 6,
      motorway_fit: 8,
      family_fit: 8,
      premium_feel: 6,
      long_term_confidence: 7
    },

    notes: {
      short_reason: "Strong family SUV petrol benchmark.",
      tradeoff: "Fuel and maintenance costs rise over longer ownership."
    }
  },

  {
    id: "skoda_karoq_1_5_tsi_petrol",
    status: "active",
    brand: "Skoda",
    model: "Karoq",
    variant: "1.5 TSI Petrol",
    display_name: "Skoda Karoq 1.5 TSI Petrol",
    fuel_type: "petrol",
    segment: "family_suv",
    body_type: "suv",
    size_class: "D",

    pricing: {
      new_price_gbp: 33900,
      used_price_bands_gbp: {
        "2_4": 22995,
        "5_7": 17995,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 44.8,
      co2_g_km: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: 60000
    },

    cost_links: {
      maintenance_band: "petrol_family_suv",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 6,
      motorway_fit: 8,
      family_fit: 8,
      premium_feel: 6,
      long_term_confidence: 8
    },

    notes: {
      short_reason: "Practical petrol family SUV comparator.",
      tradeoff: "Not as cheap to run as EV alternatives."
    }
  },

  {
    id: "vw_golf_1_5_tsi_petrol",
    status: "active",
    brand: "Volkswagen",
    model: "Golf",
    variant: "1.5 TSI Petrol",
    display_name: "Volkswagen Golf 1.5 TSI Petrol",
    fuel_type: "petrol",
    segment: "small_hatch",
    body_type: "hatchback",
    size_class: "C",

    pricing: {
      new_price_gbp: 28600,
      used_price_bands_gbp: {
        "2_4": 19995,
        "5_7": 14995,
        "8_10": null
      }
    },

    efficiency: {
      combined_mpg_uk: 51.4,
      co2_g_km: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: 60000
    },

    cost_links: {
      maintenance_band: "petrol_small_hatch",
      ved_profile: "standard_post_2017"
    },

    scores: {
      city_fit: 7,
      motorway_fit: 8,
      family_fit: 6,
      premium_feel: 6,
      long_term_confidence: 7
    },

    notes: {
      short_reason: "Solid petrol hatchback benchmark for EV hatch comparisons.",
      tradeoff: "Fuel spend remains much higher than EV over time."
    }
  }
];